import { TemplateTypeAPI } from "src/requests/administration/types";
import typeGuards from "src/type-guards";
import {
  CellEntity,
  MobileRowLayout,
} from "../../../components/organisms/ColumnTemplatePositionEditor/types";
import {
  MobileRowLayoutDTO,
  TemplateMetadataAPI,
} from "../../../requests/templates/types";
import { TemplateMetadataDISPATCH } from "../types";

function mapMobileRowLayout(
  mobileRowLayoutAPI: MobileRowLayoutDTO | null
): MobileRowLayout | undefined {
  if (mobileRowLayoutAPI === null) return undefined;

  const { columns, rows, layout, delimiters } = mobileRowLayoutAPI;

  const cellEntities: CellEntity[] =
    layout === null
      ? []
      : Object.values(layout).map(({ columnValueIndex, ...rest }) => ({
          ...rest,
          presentationTemplateItemId: columnValueIndex,
          prevX: NaN,
          prevY: NaN,
        }));

  return {
    width: columns,
    height: rows,
    cellEntities,
    delimiters,
  };
}

// eslint-disable-next-line
export const mapApiToDispatch = (templateMetadataApi: TemplateMetadataAPI) => {
  const templateMetadataDispatch: TemplateMetadataDISPATCH = {
    ...templateMetadataApi,
    mobileRowLayout: mapMobileRowLayout(templateMetadataApi.mobileRowLayout),
    desktopRowLayout: mapMobileRowLayout(templateMetadataApi.desktopRowLayout),
  };

  return templateMetadataDispatch;
};

export const getIsTopLevel = (type?: TemplateTypeAPI) => {
  if (!type) return false;

  const { isTopLevel } = typeGuards.forTemplateType;

  return isTopLevel(type);
};
